import { LoginView } from 'features/auth';

const LoginPage = () => <LoginView />;

export default LoginPage;
